/**
 * Get the URL + path part of a given JS file -> for dynamic loading of assets
 */
export default function getUrlPath(fileName) {
    const scriptElem = document.querySelector(`script[src*="${fileName}"]`);
    let urlPath = '/assets/js'; // default
    if (scriptElem) {
        const tempLink = document.createElement('a');
        tempLink.setAttribute('href', scriptElem.getAttribute('src') || urlPath);
        urlPath = tempLink.href.replace(`/${fileName}`, ''); // no trailing slash
    }
    return urlPath;
}
